import { RouteObject } from 'react-router-dom';

import { COUNTRY } from '@/config/country';

import { Authorize } from '@/components';
import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

import Shippings from '../Shippings';
import {
  CreateShippings,
  CloneShipping,
  ViewShipping,
  EditShipping,
  RouteBuilder,
  Locations,
  PickupAudit,
  MeliOrders,
  ImportShippings,
  CorreoDeliveriesImport,
} from '../pages';

const ShippingsRoutes: RouteObject[] = [
  {
    path: 'shippings',
    element: <Shippings />,
  },
  {
    path: 'shippings/pickup-audit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <PickupAudit />
      </Authorize>
    ),
  },
  {
    path: 'shippings/pickup-audit/locations',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <Locations />
      </Authorize>
    ),
  },
  {
    path: 'shippings/create',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <CreateShippings />
      </Authorize>
    ),
  },
  {
    path: 'shippings/routing',
    element: 
    <Authorize permission={BUSINESS_ROLE_GROUPS.adminOrDispatcher} fallback={<ErrorPage code={403} />}>
      <RouteBuilder />
    </Authorize>,
  },
  {
    path: 'shippings/import',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <ImportShippings />
      </Authorize>
    ),
  },
  /*
   * Solo Uruguay: el Correo Uruguayo es el operador de este archivo, y en Perú
   * ni existe la tabla de trackings contra la que se buscan los pedidos ni la
   * transición que aplica la entrega. Registrar la pantalla allá sería ofrecer
   * un import que no puede terminar bien.
   */
  ...(COUNTRY === 'uy'
    ? [
        {
          path: 'shippings/correo-deliveries-import',
          element: (
            <Authorize
              permission={BUSINESS_ROLE_GROUPS.operations}
              fallback={<ErrorPage code={403} />}
            >
              <CorreoDeliveriesImport />
            </Authorize>
          ),
        },
      ]
    : []),
  {
    path: 'shippings/meli-orders',
    element: <MeliOrders />,
  },
  {
    path: 'shipping/:number',
    element: <ViewShipping />,
  },
  {
    path: 'shipping/:number/edit',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <EditShipping />
      </Authorize>
    ),
  },
  {
    path: 'shipping/:number/clone',
    element: (
      <Authorize
        permission={BUSINESS_ROLE_GROUPS.operations}
        fallback={<ErrorPage code={403} />}
      >
        <CloneShipping />
      </Authorize>
    ),
  },
];

export default ShippingsRoutes;
